import { render } from "./UriList.vue?vue&type=template&id=a6066784"
import script from "./UriList.vue?vue&type=script&lang=js"
export * from "./UriList.vue?vue&type=script&lang=js"

import "./UriList.vue?vue&type=style&index=0&id=a6066784&lang=css"

import exportComponent from "/Users/LIU/Project/oab-patientmanagement/oab-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__